import React from "react";
import FAQPageComponent from "../components/FAQ/index";

const FAQPage = () => {
  return (
    <>
      <FAQPageComponent />
    </>
  );
};

export default FAQPage;
